import { render, staticRenderFns } from "./NumberInfo.vue?vue&type=template&id=a16f84d8&scoped=true&"
import script from "./NumberInfo.vue?vue&type=script&lang=js&"
export * from "./NumberInfo.vue?vue&type=script&lang=js&"
import style0 from "./NumberInfo.vue?vue&type=style&index=0&id=a16f84d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16f84d8",
  null
  
)

export default component.exports